import {cartoon182} from './182.js';
import {cartoon183} from './183.js';
import {cartoon186} from './186.js';

export const carton = [].concat(cartoon182).concat(cartoon183).concat(cartoon186);